import { inject, isDevMode } from '@angular/core';
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';

const LANDPAGE_ROUTE = 'landpage';

export const testGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const activatedRoute = inject(ActivatedRoute);

    if (isDevMode()) {
        return true
    }

    router.navigate([LANDPAGE_ROUTE], { relativeTo: activatedRoute.parent });
    return false;
};
